import { render, staticRenderFns } from "./emailAttachments.vue?vue&type=template&id=915edef4&"
import script from "./emailAttachments.vue?vue&type=script&lang=js&"
export * from "./emailAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports